import React from 'react';
import { WrappedFieldInputProps } from 'redux-form';
import { TextField as MUITextField, TextFieldProps } from '@ha/dsl';
import { fromMUIComponent } from 'ha/helpers/forms/redux-form/muiHelpers';
import { WrappedFieldMetaProps } from 'redux-form/lib/Field';

class TextFieldInternal extends React.Component<TextFieldProps> {
  render() {
    return <MUITextField {...this.props} />;
  }
}

type SubmitErrors = {
  submitError?: string;
  submitFailed?: boolean;
};

type MapProps<P> = (p: Mix<P>) => P;
type Mix<P> = P & WrappedFieldPropsNew;

interface WrappedFieldPropsNew {
  // interface is overwritten to add submitErrors type to the meta
  input: WrappedFieldInputProps;
  meta: WrappedFieldMetaProps & SubmitErrors;
}

const mapError: MapProps<TextFieldProps> = ({
  meta: { touched, error, warning, submitError, submitFailed },
  input,
  meta,
  ...props
}) => {
  const errorOrWarning = error || warning;
  const errorProps: TextFieldProps & WrappedFieldInputProps =
    touched && errorOrWarning
      ? {
          ...props,
          ...input,
          error: Boolean(errorOrWarning),
        }
      : { ...input, ...props };

  if (touched && errorOrWarning) {
    errorProps.helperText = errorOrWarning;
  } else if (submitError && submitFailed) {
    errorProps.helperText = submitError;
    errorProps.error = true;
  }

  return errorProps;
};

const TextField = fromMUIComponent<TextFieldProps>(
  TextFieldInternal,
  ({ defaultValue, ...props }: Mix<TextFieldProps>) => ({
    ...mapError(props),
  }),
);
export { TextField };
